




import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class Purpose extends Vue {
    @Prop() id!: number;

    get translatedValue() {
        switch (this.id) {
            case 1:
                return "for sale";
                break;
            case 2:
                return "for rent";
                break;
            case 3:
                return "life annuity sale";
                break;
        }
        return "";
    }
}
